import { ProductPricingModel } from '../enums/productPricingModel'
import { ProductType } from '../enums/productType'
import { ProductUnitCode } from '../enums/productUnitCode'
import { Product } from '../types/product'

export const DEFAULT_PRODUCT_UNIT_CODE = ProductUnitCode.Piece

export const DEFAULT_PRODUCT: Product = {
  id: '',
  name: '',
  pricingModel: ProductPricingModel.Price,
  productType: ProductType.Goods,
  unit: '',
  vatPct: 0,
}
